import React from 'react';
import { Outlet } from 'react-router-dom';

import WpSessionDropdown from '@dashboard/components/SessionDropdown';
import { WhiteWaypointLogo } from '@dashboard/components/WaypointLogo';
import { AppBar, Box, Container, Toolbar } from '@mui/material';

export default function UserManagementPageLayout() {
  return (
    <>
      <AppBar color="primary" position="static">
        <Container maxWidth="xl">
          <Toolbar
            disableGutters
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <WhiteWaypointLogo />
            <Box maxWidth={512}>
              <WpSessionDropdown />
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Container maxWidth="xl" sx={{ py: 2 }}>
        <Outlet />
      </Container>
    </>
  );
}
